import { createFileRoute } from '@tanstack/react-router'
import { PlusCircle } from 'lucide-react'
import { useCreateBlog } from '@/hooks/data/useBlog'
import BlogEditorForm from '@/components/blog/BlogEditorForm'

function NewBlogPostPage() {
  const create = useCreateBlog()

  return (
    <div className="p-2 md:p-4 space-y-4">
      <h1 className="text-2xl font-bold text-gray-800 dark:text-white flex items-center gap-2">
        <PlusCircle className="w-6 h-6" /> New Blog Post
      </h1>
      <BlogEditorForm submitLabel="Publish" onSubmit={async (input) => { await create.mutateAsync(input) }} />
    </div>
  )
}

export const Route = createFileRoute('/(admin)/blog/new/')({
  component: NewBlogPostPage,
})
